
import { Translations } from './types';
import { germanTranslations } from './de';
import { englishTranslations } from './en';
import { frenchTranslations } from './fr';
import { italianTranslations } from './it';

export const translations: Translations = {
  de: germanTranslations,
  en: englishTranslations,
  fr: frenchTranslations,
  it: italianTranslations
};
